import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { SizeRecord } from "../../helper/SizeRecord";
import { ItemTypeDisplayValues } from "../shared/ItemTypeDisplayValues";

export const SearchResultRecord = Record({
  id: null,
  typeData: ItemTypeDisplayValues(),
  displayId: null,
  initials: null,
  label: null,
  summary: null,
  color: null,
  identifierSize: SizeRecord(),
  selected: false
});

const data = {
  objects: {
    typeData: "ItemTypeDisplayValues",
    identifierSize: "SizeRecord"
  }
};
createFromJS.registerCallback("SearchResultRecord", createFromJS.createNestedCallback(SearchResultRecord, data));
